// Mutation Query for FormData

// eslint-disable-next-line import/prefer-default-export
export const MUTATION_SAVE_FIELD_DATA = `
  mutation ($tourid: String, $currentStep: String, $module_id: String, $locId: String, $instId: String, $source: String , $lastCompletedStep: Int, $onCampus: Boolean, $userkey: String, $sessionid: String, $testing: Boolean, $completed: Boolean, $embedType: String $fieldData:[FieldData]) {
    formDataSubmissionMutation (tourID: $tourid, currentStep:$currentStep, lastCompletedStep:$lastCompletedStep, instID:$instId, locID: $locId, source: $source, module_id: $module_id, onCampus: $onCampus, userkey:$userkey, sessionid:$sessionid, testing: $testing, completed: $completed, embed_type: $embedType, fieldData: $fieldData) {
      status    
      message
      data
    }
  }
`;
